import type { PackageType, PackageTier } from '@client/api';

import type { OnboardingBuilding, ImportCompanyCandidate } from '../../onboarding/onboarding.types';

/**
 * A package selection for one building, scoped to the in-tenant building wizard.
 * Mirrors the BE's <c>BulkBuildingPackagePayload</c>.
 */
export interface WizardBuildingPackage {
  packageType: PackageType;
  tier: PackageTier;
}

export interface BuildingWizardState {
  currentStep: number;
  buildings: OnboardingBuilding[];
  importCompanies: ImportCompanyCandidate[];
  /**
   * Per-building package selections, keyed by <c>OnboardingBuilding.id</c> (the FE-only
   * draft id assigned in StepBygg). The handler aligns these by index when posting.
   */
  packagesByBuildingId: Record<string, WizardBuildingPackage[]>;
}

export const BUILDING_WIZARD_STEPS = [
  { key: 'bygg', label: 'BYGG' },
  { key: 'roller', label: 'ROLLER' },
  { key: 'importer', label: 'LEIETAKERE' },
  { key: 'pakker', label: 'PAKKER' },
  { key: 'gjennomgang', label: 'GJENNOMGANG' },
  { key: 'ferdig', label: 'FERDIG' },
] as const;

// Step indices — keep in sync with BUILDING_WIZARD_STEPS order.
export const STEP_BYGG = 0;
export const STEP_ROLLER = 1;
export const STEP_IMPORTER = 2;
export const STEP_PAKKER = 3;
export const STEP_GJENNOMGANG = 4;
export const STEP_FERDIG = 5;
